import useMap from 'hooks/use-map'
import { transformExtent } from 'ol/proj'

const DEFAULT_PADDING = [65, 60, 110, 15]

export default function FocusField(props) {
  const { boundary, active = true } = props
  const defaultExtent = useSelector((state) => state.field['defaultExtent'])

  const map = useMap()

  useEffect(() => {
    if (active) {
      if (boundary !== undefined) {
        try {
          map.getView().fit(boundary.getGeometry().getExtent(), {
            padding: DEFAULT_PADDING,
          })
        } catch (e) {
          console.log(e)
        }
      }
    } else if (map && defaultExtent && defaultExtent.length > 0) {
      map
        .getView()
        .fit(transformExtent(defaultExtent, 'EPSG:4326', 'EPSG:3857'))
    }
  }, [map, boundary, active, defaultExtent])

  return null
}
